/** Affichage aéré du numéro pendant la frappe : 77 200 90 89. */
export function prettyPhone(value: string): string {
  const hasPlus = value.trim().startsWith('+');
  const digits = value.replace(/\D/g, '').slice(0, 15);
  const grouped = digits.replace(/(\d{2})(?=\d)/g, '$1 ').trim();
  return hasPlus ? `+${grouped}` : grouped;
}

/**
 * Forme envoyée au serveur : `+` et chiffres, sans espace.
 *
 * L'inscription refuse les espaces et le zéro initial (format E.164). Un
 * numéro national à neuf chiffres reçoit l'indicatif du Sénégal ; un numéro
 * saisi avec `+` ou `00` garde le sien.
 */
export function toE164(value: string): string {
  const trimmed = value.trim();
  const digits = trimmed.replace(/\D/g, '');

  if (trimmed.startsWith('+')) return `+${digits}`;
  if (digits.startsWith('00')) return `+${digits.slice(2)}`;
  if (digits.length === 9) return `+221${digits}`;
  return `+${digits}`;
}

export function isPlausiblePhone(value: string): boolean {
  return value.replace(/\D/g, '').length >= 9;
}
